import { put, call, takeLatest, select } from 'redux-saga/effects';

import isEmpty from 'lodash/isEmpty';

import { formatError } from '../../../libs';
import sitemapAPI from '../../api/sitemap';
import { Creators as GlobalCreators } from '../../reducers/global';
import { Types, Creators as SiteMapCreators } from '../../reducers/sitemap';
import getState from '../../utils/getState';

function* getCategories() {
  try {
    const { app } = yield select(getState);
    const siteId = app.getIn(['config', 'siteId']);

    const data = yield call(sitemapAPI.getCategories, siteId);

    if (isEmpty(data)) {
      throw 'SiteMap get categories not found';
    }

    yield put(
      SiteMapCreators.getCategoriesSuccess({ categories: data.items.category, fullCategories: data.items.category })
    );
  } catch (error) {
    yield put(GlobalCreators.errorApp(error));
    yield put(SiteMapCreators.getCategoriesError(formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.GET_CATEGORIES_REQUEST, getCategories);
}
